import React, {
  useEffect,
  useRef,
  useState
} from "react";
import {
  CircularProgress
} from "@material-ui/core"
import * as pdfjs from "pdfjs-dist";
import {
  AUTHORIZE_DOWNLOAD_GET
} from "config/url";
// import {
//   TextLayerBuilder
// } from "pdfjs-dist/web/pdf_viewer";
// import "pdfjs-dist/web/pdf_viewer.css";

const style = {
  containerStyle : {
    position : "relative",
    textAlign : "center",
    minHeight : "100%"
  },
  progress : {
    position : "absolute",
    top : "50%",
    left : "50%",
    transform : "translate(-50%, -50%)"
  },
  contentStyle : {
    border : "1px solid black",
    direction: "ltr",
    display : "inline-block"
  }
}

export default function AuthorizationList(props){
  const {
    fileId
  } = props;
  const [fetching, setFetching] = useState(true);
  const pdfViewer = useRef();
  const isMounted = useRef();
  useEffect(() => {
    isMounted.current = true;
    if(!fileId) return false;
    const el = pdfViewer.current;
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const mission = pdfjs.getDocument(`${AUTHORIZE_DOWNLOAD_GET}?code=${fileId}`);
    mission.promise.then((pdf) => {
      if(!isMounted.current) return false;
      setFetching(false);
      for(let i = 1; i <= pdf.numPages; i++){
        pdf.getPage(i).then(function(page) {
          const scale = 1.5;
          const viewport = page.getViewport({ scale: scale, });
          const canvas = document.createElement("canvas");
          el.appendChild(canvas);
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style = "display : block;";
          //
          // Render PDF page into canvas context
          //
          var renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          page.render(renderContext);
        });
      }

    })
    return () => {
      isMounted.current = false;
    }
  }, [fileId])

  return (
    <div style={style.containerStyle}>
      {fetching && <div style={style.progress}>
        <CircularProgress/>  
      </div>}
      <div ref={pdfViewer} style={style.contentStyle}></div>
    </div>
  )
}